import { log, ADAPTER_STATUS } from '@web3auth/base';
import { useEffect } from 'react';
import { MODAL_STATUS } from '../interfaces.js';
import Icon from './Icon.js';
import { jsxs, jsx } from 'react/jsx-runtime';

const closeIcon = /*#__PURE__*/jsx(Icon, {
  iconName: "close"
});
function Loader(props) {
  const {
    message,
    modalStatus,
    label,
    onClose,
    canEmit = true
  } = props;
  useEffect(() => {
    log.debug("loader re-rendering");
    if (modalStatus === MODAL_STATUS.CONNECTED && canEmit) {
      setTimeout(() => {
        onClose();
      }, 3000);
    }
  }, [canEmit, modalStatus, onClose]);
  return modalStatus !== MODAL_STATUS.INITIALIZED ? /*#__PURE__*/jsxs("div", {
    className: "w3ajs-modal-loader w3a-modal__loader",
    children: [/*#__PURE__*/jsx("div", {
      className: "w3a-modal__loader-content",
      children: /*#__PURE__*/jsxs("div", {
        className: "w3a-modal__loader-info",
        children: [modalStatus === MODAL_STATUS.CONNECTING && /*#__PURE__*/jsx("div", {
          className: "w3ajs-modal-loader__spinner w3a-spinner",
          children: /*#__PURE__*/jsx("div", {
            className: "w3a-spinner__spinner"
          })
        }), /*#__PURE__*/jsx("div", {
          className: "w3ajs-modal-loader__label w3a-spinner-label",
          children: label
        }), modalStatus === ADAPTER_STATUS.CONNECTED && /*#__PURE__*/jsx("div", {
          className: "w3ajs-modal-loader__message w3a-spinner-message",
          children: message
        }), modalStatus === ADAPTER_STATUS.ERRORED && /*#__PURE__*/jsx("div", {
          className: "w3ajs-modal-loader__message w3a-spinner-message w3a-spinner-message--error",
          children: message
        })]
      })
    }), (modalStatus === ADAPTER_STATUS.CONNECTED || modalStatus === ADAPTER_STATUS.ERRORED) && /*#__PURE__*/jsx("button", {
      type: "button",
      className: "w3a-header__button w3ajs-loader-close-btn",
      onClick: onClose,
      children: closeIcon
    })]
  }) : null;
}

export { Loader as default };
